module.exports = __webpack_public_path__ + "img/dummy12.46c1625.jpg";